export default __webpack_public_path__ + "static/media/bw.543b804a.svg";